import React, {useEffect, useRef, useState} from "react";
import {Field} from "react-final-form";
import {
    composeValidators,
    maxLengthValidate,
    minLengthValidate,
    regRequiredValidate,
    // validateNewConfirmPasswordField,
} from "../../../../containers/RegistrationLoginPage/registrationValidation";
import TextField from "../../../HTMLEntities/Textfield";
import {FieldSchema, FormType} from "../../../../containers/RegistrationLoginPage/types";
import {TextInTextField} from "../../../HTMLEntities/Textfield/widgets/Styled";
import {errorHandler} from "../../../../containers/RegistrationLoginPage/errorUtils";
import Anchor from "../../../HTMLEntities/Anchor";
import {ChangePasswordLink} from "../Styled";
interface PasswordFieldInterface {
    configuration: FieldSchema;
    autoComplete?: "off" | "new-password" | "current-password";
    customValidation?: ((msg: string) => string | undefined)[];
    hiddenText?: boolean;
    placeholder?: string;
    formType?: FormType;
}
const PasswordField: React.FC<PasswordFieldInterface> = ({
    configuration,
    autoComplete = "off",
    customValidation,
    hiddenText = false,
    placeholder,
    formType,
}: PasswordFieldInterface) => {
    const {fieldName, editable} = configuration;
    const [hideText, setHiddenText] = useState(hiddenText);
    const isMounted = useRef(false);
    useEffect(() => {
        if (isMounted.current) {
            setHiddenText(hiddenText);
        }
        isMounted.current = true;
    }, [hiddenText]);

    if (formType === "editProfile") {
        return (
            <Anchor isPWALink={true} linkHref={"/change-password"}>
                <ChangePasswordLink>Change Password</ChangePasswordLink>
            </Anchor>
        );
    }
    const validation = [
        regRequiredValidate("Password is mandatory"),
        minLengthValidate(6, "Please enter minimum 6 characters"),
        maxLengthValidate(25, "Password cannot exceed 25 characters"),
    ];

    return (
        <Field<string>
            name={fieldName}
            validate={
                customValidation
                    ? composeValidators(...validation, ...customValidation)
                    : composeValidators(...validation)
            }
        >
            {(props) => {
                return (
                    <>
                        <TextField
                            placeholder={placeholder ? placeholder : "password"}
                            type={hideText ? "password" : "text"}
                            autoComplete={autoComplete}
                            minLength={6}
                            maxLength={25}
                            initialValue={props?.input?.value ?? ""}
                            isFocused={props?.meta?.active ?? false}
                            isFilled={props?.input?.value.length > 0}
                            error={errorHandler(props?.meta)}
                            isTouched={props?.meta?.touched}
                            isDisabled={!editable}
                            inputRFF={props?.input}
                            InnerTextFieldComponent={
                                <TextInTextField onClick={() => setHiddenText(!hideText)}>
                                    {hideText ? "Show" : "Hide"}
                                </TextInTextField>
                            }
                        />
                    </>
                );
            }}
        </Field>
    );
};
export default PasswordField;
